import axios from "axios";
import i18n from "../../i18n";

const actions = {
  getAllProofCategories(context) {
    return axios
      .get("proofCategory")
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  createProofCategory(context, value) {
    return axios
      .post("proofCategory", value)
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("proof.category.createdMessage", { name: r.data.name }));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  updateProofCategory(context, value) {
    return axios
      .put("proofCategory/" + value.id, value)
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("proof.category.updatedMessage", { name: r.data.name }));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  deleteProofCategory(context, value) {
    return axios
      .delete("proofCategory/" + value.id)
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("proof.category.deletedMessage"));
        return r;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  getSingleProofCategory(context, id) {
    return axios
      .get("proofCategory/" + id)
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  getProofCategoryCounts(context) {
    return axios
      .get("proofCategory/counts")
      .then((r) => r.data.counts || {})
      .catch((e) => context.dispatch("triggerError", e));
  },
};

export default actions;
